import {Inject, Injectable} from '@angular/core';
import {ExceptionHandlerService} from './exception-handler-service';
import {EXCEPTION_HANDLER_TOKEN} from '../tokens/exception-handler-token';
import {FallbackExceptionHandler} from '../models/exception-handlers/fallback.exception-handler';
import {DialogService} from './dialog.service';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ExceptionDispatcherService {

  constructor(@Inject(EXCEPTION_HANDLER_TOKEN) private readonly exceptionHandlers: ExceptionHandlerService[],
              private readonly dialogService: DialogService,
              private readonly authService: AuthService) {
  }

  /**
   * Evaluates the occurred exception during an HTTP request and gives back the responsible ExceptionHandler implementation.
   *
   * @param httpError the HTTP error that occurred.
   */
  public evaluate(httpError: any): ExceptionHandlerService {
    return this.exceptionHandlers.find(handler => handler.isResponsible(httpError)) || new FallbackExceptionHandler(this.dialogService, this.authService);
  }
}
